/* Barre de paliers partagée (pages produit) — Hedonist 2026
   <hc-tiers> : recalcule en direct la progression vers les paliers du panier natif.
   Base = produits éligibles déjà au panier (fetch /cart.js, mêmes handles que le panier)
        + sélection en cours = somme des <input data-hc-qty data-hc-price="centimes">.
   Se met à jour : clics sur les boutons +/- et sélecteurs de pack (scripts jQuery existants),
   changements d'input, événement hc:cart:refreshed (cart-2026.js), retour bfcache (pageshow). */
(function () {
  'use strict';

  if (!window.customElements || customElements.get('hc-tiers')) return;

  function parseInt10(v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? 0 : n;
  }

  function groupThousands(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function formatMoney(cents, format) {
    var fmt = format || '{{amount}}';
    var match = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var key = match ? match[1] : 'amount';
    var value = Math.max(0, cents) / 100;
    var fixed = value.toFixed(2);
    var parts = fixed.split('.');
    var out;
    switch (key) {
      case 'amount_no_decimals':
        out = groupThousands(String(Math.round(value)), ',');
        break;
      case 'amount_with_comma_separator':
        out = groupThousands(parts[0], '.') + ',' + parts[1];
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = groupThousands(String(Math.round(value)), '.');
        break;
      case 'amount_with_space_separator':
        out = groupThousands(parts[0], ' ') + ',' + parts[1];
        break;
      case 'amount_no_decimals_with_space_separator':
        out = groupThousands(String(Math.round(value)), ' ');
        break;
      case 'amount_with_apostrophe_separator':
        out = groupThousands(parts[0], "'") + '.' + parts[1];
        break;
      case 'amount_with_period_and_space_separator':
        out = groupThousands(parts[0], ' ') + '.' + parts[1];
        break;
      default:
        out = groupThousands(parts[0], ',') + '.' + parts[1];
    }
    return match ? fmt.replace(match[0], out) : out;
  }

  function fillTemplate(tpl, amountHtml, rewardHtml) {
    return String(tpl || '')
      .replace(/\{\{\s*amount\s*\}\}/g, amountHtml)
      .replace(/\{\{\s*reward\s*\}\}/g, rewardHtml)
      .replace(/\*/g, '');
  }

  var HcTiers = function () {
    return Reflect.construct(HTMLElement, [], this.constructor);
  };
  HcTiers.prototype = Object.create(HTMLElement.prototype);
  HcTiers.prototype.constructor = HcTiers;
  Object.setPrototypeOf(HcTiers, HTMLElement);

  HcTiers.prototype.connectedCallback = function () {
    var self = this;
    if (this.__hcInit) return;
    this.__hcInit = true;

    try {
      this.tiers = JSON.parse(this.getAttribute('data-tiers') || '[]');
    } catch (e) {
      this.tiers = [];
    }
    this.eligible = (this.getAttribute('data-eligible') || '')
      .toLowerCase()
      .split(',')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
    this.cartUrl = this.getAttribute('data-cart-url') || '/cart.js';
    this.cartBase = parseInt10(this.getAttribute('data-cart-base'));
    this.moneyFormat = this.getAttribute('data-money-format') || '{{amount}}';
    this.tpl = {
      preShipping: this.getAttribute('data-pre-shipping') || '',
      preDiscount: this.getAttribute('data-pre-discount') || '',
      postShipping: this.getAttribute('data-post-shipping') || '',
      postDiscount: this.getAttribute('data-post-discount') || ''
    };

    this.els = {
      pre: this.querySelector('[data-hc-pre]'),
      post: this.querySelector('[data-hc-post]'),
      bar: this.querySelector('[data-hc-bar]'),
      fill: this.querySelector('[data-hc-fill]'),
      ticks: Array.prototype.slice.call(this.querySelectorAll('[data-hc-tick]')),
      labels: Array.prototype.slice.call(this.querySelectorAll('[data-hc-label]'))
    };

    this._scheduled = null;
    this.schedule = function () {
      if (self._scheduled) return;
      self._scheduled = window.requestAnimationFrame(function () {
        self._scheduled = null;
        self.update();
      });
    };

    this._onClick = function (event) {
      var t = event.target;
      if (!t || !t.closest) return;
      if (t.closest('.btnqty, .selectpackbox, input[name="selectprdqnt"], [data-hc-qty-trigger]')) {
        self.schedule();
        // les handlers jQuery modifient l'attribut value de façon synchrone ; second passage de sécurité
        window.setTimeout(function () {
          self.update();
        }, 60);
      }
    };
    this._onInput = function (event) {
      var t = event.target;
      if (t && t.matches && t.matches('[data-hc-qty]')) self.schedule();
    };
    this._onCart = function () {
      self.syncCart();
    };
    this._onPageShow = function (event) {
      if (event && event.persisted) self.syncCart();
      else self.schedule();
    };

    document.addEventListener('click', this._onClick);
    document.addEventListener('input', this._onInput);
    document.addEventListener('change', this._onInput);
    document.addEventListener('hc:cart:refreshed', this._onCart);
    window.addEventListener('pageshow', this._onPageShow);

    this.update();
    this.syncCart();
  };

  HcTiers.prototype.disconnectedCallback = function () {
    document.removeEventListener('click', this._onClick);
    document.removeEventListener('input', this._onInput);
    document.removeEventListener('change', this._onInput);
    document.removeEventListener('hc:cart:refreshed', this._onCart);
    window.removeEventListener('pageshow', this._onPageShow);
    this.__hcInit = false;
  };

  HcTiers.prototype.selection = function () {
    var total = 0;
    var inputs = document.querySelectorAll('[data-hc-qty]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      if (el.disabled) continue;
      var qty = parseInt10(el.value);
      if (qty <= 0) continue;
      var price = parseInt10(el.getAttribute('data-hc-price'));
      total += qty * price;
    }
    return total;
  };

  HcTiers.prototype.syncCart = function () {
    var self = this;
    if (!window.fetch) return;
    fetch(this.cartUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        var base = 0;
        var items = (cart && cart.items) || [];
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (!self.eligible.length || self.eligible.indexOf(String(it.handle || '').toLowerCase()) > -1) {
            base += parseInt10(it.original_line_price);
          }
        }
        self.cartBase = base;
        self.update();
      })
      .catch(function () {
        /* on garde la base rendue côté serveur */
      });
  };

  HcTiers.prototype.update = function () {
    var tiers = this.tiers;
    var n = tiers.length;
    if (!n) return;
    var base = this.cartBase + this.selection();

    var unlocked = 0;
    var next = -1;
    for (var i = 0; i < n; i++) {
      if (base >= tiers[i].a) unlocked++;
      else if (next < 0) next = i;
    }

    var pct = 100;
    var remaining = 0;
    if (next >= 0) {
      var lower = next > 0 ? tiers[next - 1].a : 0;
      var upper = tiers[next].a;
      var span = upper - lower;
      var frac = span > 0 ? Math.min(1, Math.max(0, (base - lower) / span)) : 0;
      pct = Math.round(((unlocked + frac) * 100 / n) * 100) / 100;
      remaining = upper - base;
    }
    if (pct > 100) pct = 100;

    var els = this.els;
    if (els.fill) els.fill.style.width = pct + '%';
    if (els.bar) {
      els.bar.setAttribute('aria-valuenow', String(Math.round(pct)));
    }
    for (var t = 0; t < els.ticks.length; t++) {
      els.ticks[t].classList.toggle('is-unlocked', t + 1 <= unlocked);
    }
    for (var l = 0; l < els.labels.length; l++) {
      els.labels[l].classList.toggle('is-unlocked', l < unlocked);
    }

    if (els.pre) {
      if (next >= 0) {
        var nt = tiers[next];
        var preTpl = nt.t === 'shipping' ? this.tpl.preShipping : this.tpl.preDiscount;
        els.pre.innerHTML = fillTemplate(
          preTpl,
          '<strong class="hc-tiers__amount">' + formatMoney(remaining, this.moneyFormat) + '</strong>',
          '<strong class="hc-tiers__reward">' + nt.l + '</strong>'
        );
        els.pre.hidden = false;
      } else {
        els.pre.hidden = true;
      }
    }

    if (els.post) {
      if (unlocked > 0) {
        var lt = tiers[unlocked - 1];
        var postTpl = lt.t === 'shipping' ? this.tpl.postShipping : this.tpl.postDiscount;
        els.post.innerHTML = fillTemplate(postTpl, '', '<strong class="hc-tiers__reward">' + lt.l + '</strong>');
        els.post.hidden = false;
      } else {
        els.post.hidden = true;
      }
    }

    this.classList.toggle('hc-tiers--complete', next < 0);
    this.setAttribute('data-hc-unlocked', String(unlocked));
  };

  customElements.define('hc-tiers', HcTiers);
  window.HcTiers = HcTiers;
})();
